import { render, staticRenderFns } from "./PrView.vue?vue&type=template&id=f66e34e2&scoped=true&"
import script from "./PrView.vue?vue&type=script&lang=js&"
export * from "./PrView.vue?vue&type=script&lang=js&"
import style0 from "./PrView.vue?vue&type=style&index=0&id=f66e34e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66e34e2",
  null
  
)

export default component.exports